import axios from "axios";
import { getBackendURL } from "../services/config";

const api = axios.create({
	baseURL: getBackendURL(),
	withCredentials: true,
});

const parseStoredToken = () => {
	if (typeof window === "undefined") {
		return null;
	}

	const stored = localStorage.getItem("token");
	if (!stored) {
		return null;
	}

	try {
		const parsed = JSON.parse(stored);
		return typeof parsed === "string" ? parsed : null;
	} catch (_error) {
		return stored;
	}
};

api.interceptors.request.use(config => {
	const token = parseStoredToken();
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}

	if (config.url === '/auth/refresh_token') {
		config.headers['Cache-Control'] = 'no-cache';
		config.headers['Pragma'] = 'no-cache';
	}

	return config;
});

export const openApi = axios.create({
	baseURL: getBackendURL()
});

// Importar para compatibilidade (mantém a API consistente)
export { getIsLoggingOut, setIsLoggingOut } from "../utils/logoutManager";

export default api;
